class AppNotification {
  constructor() {
    this.reference = "";
    this.receivedAt = 0;
    this.emittedAt = 0;
    this.contentName = "";
    this.title = "";
    this.description = "";
    this.metaData = {};
  }

  setReference(reference) {
    this.reference = reference;
    return this;
  }

  getReference() {
    return this.reference;
  }

  setReceivedAt(receivedAt) {
    this.receivedAt = receivedAt;
    return this;
  }

  getReceivedAt() {
    return this.receivedAt;
  }

  setEmittedAt(emittedAt) {
    this.emittedAt = emittedAt;
    return this;
  }

  setContentName(contentName) {
    this.contentName = contentName;
    return this;
  }

  getContentName() {
    return this.contentName;
  }

  getEmittedAt() {
    return this.emittedAt;
  }

  setTitle(title) {
    this.title = title;
    return this;
  }

  getTitle() {
    return this.title;
  }

  setDescription(description) {
    this.description = description;
    return this;
  }

  getDescription() {
    return this.description;
  }

  setMetaData(value, key) {
    if (key) this.metaData[key] = value;
    else this.metaData = value;
    return this;
  }

  getMetaData(key) {
    if (key) return (this.metaData || {})[key];
    return this.metaData;
  }
}

export { AppNotification };
